import { CountUp } from 'countup.js';

// Select all elements with a data-counter attribute
const counters = document.querySelectorAll('[data-counter]');

// Loop through each counter and initialise CountUp
counters.forEach(counter => {
  const rawValue = counter.getAttribute('data-counter'); // Raw value from the CMS
  const hasPlus = rawValue.includes('+'); // Check if it includes '+'
  const targetValue = parseFloat(rawValue.replace('+', '')); // Remove '+' for numeric animation
  const suffix = hasPlus ? '+' : ''; // Set suffix if '+' is present

  // Initialise CountUp
  const countUp = new CountUp(counter.id, targetValue, {
    duration: 2, // Animation duration in seconds
    decimalPlaces: targetValue % 1 !== 0 ? 1 : 0, // Add decimal places only if needed
    enableScrollSpy: true, // Enable scroll spy
    scrollSpyOnce: true, // Run animation only once
    useGrouping: false, // Disable number grouping
    suffix: suffix, // Add '+' symbol if applicable
  });

  // Start the animation
  if (!countUp.error) {
    countUp.start();
  } else {
    console.error(countUp.error);
  }
});
